export const PRIMARY = '#550372'

export const NEUTRAL_50 = '#edeefe'
export const NEUTRAL_100 = '#E4E7ED'
export const NEUTRAL_150 = '#F7F8FF'
export const NEUTRAL_300 = '#9CA3AF'
export const NEUTRAL_900 = '#40444D'

export const LIGHT_GRAY_2 = '#F5F5F7'

export const MEDIUM_GRAY = '#727272'
export const LIGHT_GRAY = '#D9D9D9'
export const BLACK = '#000000'
export const WHITE = '#FFFFFF'
export const VIVID_PURPLE = '#BD14F9'
export const PASTEL_PURPLE = '#F6DDFE'
export const LIGHT_LAVENDER = '#E6E9FF'
export const PALE_PURPLE = '#EEEEFF'
export const PALE_RIBBON = '#818EFF11'

// GRAYSCALE
export const GRAYSCALE_100 = '#FEFEFE'
export const GRAYSCALE_200 = '#F7F7F7'
export const GRAYSCALE_250 = '#DFE1E2'
export const GRAYSCALE_260 = '#E2E4E5'
export const GRAYSCALE_300 = '#D6D6D6'
export const GRAYSCALE_400 = '#999999'
export const GRAYSCALE_500 = '#5C5C5C'
export const GRAYSCALE_600 = '#1F1F1F'
export const GRAYSCALE_700 = '#151515'
export const GRAYSCALE_800 = '#6B7280'

// Additional grayscale shades
export const GRAYSCALE_50 = '#F1F3F5'
export const GRAYSCALE_150 = '#FCFCFC'
export const GRAYSCALE_BORDER = '#DEE2E6'
export const GRAYSCALE_HOVER = '#F8F9FA'

// Validity badge colors
export const VALIDITY_BG = '#000BE033'
export const VALIDITY_TEXT = '#363C5C'

export const ORANGE = '#FC5E4B'

export const BLUE = '#3452FF'
export const BLUE_PRICE = '#3450DF'
export const BLUE_FREE_TAG = '#2542E7'
export const BLUE_FREE_BG = '#A6ABFF33'

export const PALE_BLUE = '#FAFDFF'
export const LIGHT_BLUE = '#CCD4FF'
export const POWDER_BLUE = '#EBF3FE'
export const SKY_BLUE = '#DBE8FF'
export const CERULEAN_BLUE = '#1D89BD'

// BLUE RIBBON
export const BLUE_RIBBON_300 = '#9AA9FF'
export const BLUE_RIBBON_400 = '#4D68FF'
export const BLUE_RIBBON_500 = '#0022E6'
export const BLUE_RIBBON_700 = '#000B4D'
export const BLUE_RIBBON_900 = '#000626'

// CRIMSON
export const CRIMSON_100 = '#FCE4E5'
export const CRIMSON_500 = '#E7282D'
export const CRIMSON_700 = '#B71419'

export const PALE_YELLOW = '#FEF4CC'
export const LIGHT_YELLOW = '#FEFBE2'
export const MEDIUM_YELLOW = '#EFE0A1'

export const DARK_VIOLET = '#120058'

// GREEN
export const GREEN_500 = '#66D200'
export const GREEN_600 = '#096F45'

// AMBER
export const AMBER_500 = '#DCA005'
export const AMBER_400 = '#F2AF01'

// VIOLET
export const VIOLET_800 = '#120058'
export const VIOLET_700 = '#2B0139'
export const VIOLET_600 = '#550372'
export const VIOLET_500 = '#8004AB'
export const VIOLET_400 = '#AA06E4'

// GRADIENTS
export const GRADIENT_SELECTED = 'linear-gradient(135deg, #C9ECFF 1%, #82ADFF 33%, #7B69FF 62%, #9B1BFF 95%)'
export const GRADIENT_SELECTED_OVERLAY = 'linear-gradient(rgba(255, 255, 255, 0.87), rgba(255, 255, 255, 0.87)), linear-gradient(135deg, #C9ECFF 1%, #82ADFF 33%, #7B69FF 62%, #9B1BFF 95%)'
export const GRADIENT_UNSELECTED_OVERLAY = 'rgb(244, 244, 244)'
